import {CardEnum} from '@colonist/game-states'
import {UIGameCardContainerView} from '../../../../shared/scripts/ui_game/ui_game_card/UIGameCardContainerView'
import {UIGamePopupConfirmationButtons} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupConfirmationButtons'
import {UIGamePopupSelectCardToGiveToPlayer} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupSelectCardToGiveToPlayer'

export class UIWGamePopupSelectCardToGiveToPlayer extends UIGamePopupSelectCardToGiveToPlayer {
    protected createSelectedCardView() {
        const cardContainerY = this.popupImageAndDescription.y + this.popupImageAndDescription.height
        const cardContainerH = this.canvas.itemSize * 0.85
        this.selectedCardView = new UIGameCardContainerView(this.uiGameManager, 0, cardContainerY, this.canvas.popupWidth, cardContainerH, this)
        this.selectedCardView.setCardClickAction((cardEnum: CardEnum) => {
            this.clickedSelectedCard(cardEnum)
        })
    }

    protected createPlayerCardContainerView() {
        const cardsToSelectFromW = this.canvas.appW - this.canvas.itemSize * 10
        const cardsToSelectFromY = this.canvas.appH - this.canvas.itemSize
        this.cardsToSelectFrom = new UIGameCardContainerView(this.uiGameManager, 0, cardsToSelectFromY, cardsToSelectFromW, this.canvas.itemSize, this.canvas.app.stage)
    }

    protected createConfirmationButtons() {
        const bottomButtonH = this.canvas.itemSize * 0.55
        const confirmationButtonY = this.absoluteHeight - bottomButtonH
        this.confirmationButtons = new UIGamePopupConfirmationButtons(0, confirmationButtonY, this.canvas.popupWidth, bottomButtonH,
            () => this.clickedCheckAction(), () => this.cancelAction(), this)
    }

    protected setContainerY() {
        this.y = this.canvas.appH - this.canvas.itemSize - this.absoluteHeight
    }
}
